import {
  SET_ENABLE_LANGUAGES,
  SET_ENABLE_VARIANT_MANAGEMENT,
  SET_ENABLE_REPORTED_CATEGORY,
  SET_ENABLE_MULTI_PICKUP,
} from "../constants/action-types";

const initialState = {
  enable_product_language: false,
  enable_variant_management: false,
  enable_reported_category: false,
  enable_multi_pickup: false,
};

const productsSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ENABLE_LANGUAGES:
      return { ...state, enable_product_language: action.payload };
    case SET_ENABLE_VARIANT_MANAGEMENT:
      return { ...state, enable_variant_management: action.payload };
    case SET_ENABLE_REPORTED_CATEGORY:
      return { ...state, enable_reported_category: action.payload };
    case SET_ENABLE_MULTI_PICKUP:
      return { ...state, enable_multi_pickup: action.payload };
    default:
      return state;
  }
};

export default productsSettingsReducer;
